export const COMPLETE_REGISTRATION_MODAL_ID = 'complete-registration' as const
